export enum OrderStatus {
  PLACED,
  ARRIVED,
  FINALIZED,
  CANCELLED
}

export enum PaymentInfoStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
  FAILED = 'FAILED'
}

export class OrderProductDto {
  id: string;
  title: string;
  count: number;
}

export interface OrderUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}
export interface Order {
  id: string;
  pin: string;
  status: OrderStatus;
  totalPrice: number;
  paymentStatus: PaymentInfoStatus;
  items: OrderProductDto[];
  pickupDate: Date;
  createdAt: Date;
  user: OrderUser;
}
